let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eFHVS")).then(() => parcelRequire('hx1ag'));